import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Login from './pages/Login';
import AdminDashboard from './pages/admin/AdminDashboard';
import InvestorsList from './pages/admin/InvestorsList';
import InvestmentManagement from './pages/admin/InvestmentManagement';
import PayoutManagement from './pages/admin/PayoutManagement';
import InvestorDashboard from './pages/investor/InvestorDashboard';
import InvestmentDetails from './pages/investor/InvestmentDetails';
import PayoutHistory from './pages/investor/PayoutHistory';
import StatementDownload from './pages/investor/StatementDownload';
import Profile from './pages/investor/Profile';
import { useEffect, useState } from 'react';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to={user.role === 'admin' ? '/admin' : '/investor'} /> : <Login onLogin={handleLogin} />
          } />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            user?.role === 'admin' ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/admin/investors" element={
            user?.role === 'admin' ? <InvestorsList user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/admin/investments" element={
            user?.role === 'admin' ? <InvestmentManagement user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/admin/payouts" element={
            user?.role === 'admin' ? <PayoutManagement user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          
          {/* Investor Routes */}
          <Route path="/investor" element={
            user?.role === 'investor' ? <InvestorDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/investor/investments" element={
            user?.role === 'investor' ? <InvestmentDetails user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/investor/payouts" element={
            user?.role === 'investor' ? <PayoutHistory user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/investor/statement" element={
            user?.role === 'investor' ? <StatementDownload user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/investor/profile" element={
            user?.role === 'investor' ? <Profile user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          
          <Route path="/" element={
            <Navigate to={user ? (user.role === 'admin' ? '/admin' : '/investor') : '/login'} />
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;